import React from 'react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, Calendar } from 'lucide-react';

export const Hero = ({ onOpenQuiz }) => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 bg-[#050505]"
      data-testid="hero-section"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=2069)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/95 via-[#050505]/92 to-[#050505]"></div>
      
      {/* Radial Glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[900px] h-[900px] bg-[#00E599]/10 rounded-full blur-[130px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          {/* Main Headline */}
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-4xl sm:text-5xl lg:text-7xl font-headline font-bold text-[#F4F4F5] leading-tight tracking-tighter"
          >
            Stop Losing{' '}
            <span className="gradient-text">
              $5,000 Jobs
            </span>{' '}
            to Voicemail.
          </motion.h1>

          {/* Subheadline */}
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-lg sm:text-xl text-[#A1A1AA] font-body leading-relaxed max-w-4xl mx-auto"
          >
            While you are on a roof or under a sink, your AI Office Manager is answering calls, qualifying leads, and booking jobs directly into your calendar. 24/7. No sick days. No missed leads.
          </motion.p>

          {/* CTAs */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 items-center justify-center pt-6"
          >
            <Button
              onClick={onOpenQuiz}
              size="lg"
              className="bg-[#00E599] hover:bg-[#00C985] text-[#050505] whitespace-nowrap w-full sm:w-auto px-5 sm:px-10 py-5 sm:py-7 text-sm sm:text-xl font-body font-bold transition-all duration-300 hover:shadow-2xl hover:shadow-[#00E599]/40 hover:scale-105 rounded-xl"
            >
              See how many jobs you're missing.
            </Button>
          </motion.div>

          {/* Visual Feature Icons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="grid grid-cols-3 gap-6 max-w-3xl mx-auto pt-12"
          >
            <div className="flex flex-col items-center gap-3 glass p-6 rounded-xl">
              <Phone className="w-10 h-10 text-[#00E599]" />
              <p className="text-sm text-[#A1A1AA] font-body">Answers Every Call</p>
            </div>
            <div className="flex flex-col items-center gap-3 glass p-6 rounded-xl">
              <MessageSquare className="w-10 h-10 text-[#00E599]" />
              <p className="text-sm text-[#A1A1AA] font-body">Qualifies Leads</p>
            </div>
            <div className="flex flex-col items-center gap-3 glass p-6 rounded-xl">
              <Calendar className="w-10 h-10 text-[#00E599]" />
              <p className="text-sm text-[#A1A1AA] font-body">Books Jobs</p>
            </div>
          </motion.div>

          {/* Trust bar */}
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="pt-12"
          >
            <p className="text-sm text-[#A1A1AA] font-body">
              Trusted by <span className="text-[#00E599] font-semibold">500+ HVAC, Plumbing, and Electrical Contractors</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
